import React, { useEffect, useRef, useState } from 'react'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import BackIcon from 'karrierhub-ui/dist/common/src/svg/BackIcon'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import ArrowRightIcon from 'karrierhub-ui/dist/common/src/svg/ArrowRightIcon'
import { copyObject } from 'wapplr/dist/common/utils'
import { MenuBase } from 'karrierhub-ui/dist/common/src/components/Menu'

export function MegaMenu(props) {

    const {
        classNames,
        menu = [],
        MenuBaseProps = {},
        getSetTitle,
        startFromDeep = -1,
        children,
        forceOpen,
        defaultOpenMenuKey
    } = props

    const { storageOpenMenu, menuKey = 'megaMenu' } = MenuBaseProps

    const container = useRef()
    const listItems = useRef({})

    function getParents(current, key = 'parent') {
        const parents = []

        function rec(current) {
            const parent = current[key]
            if (parent) {
                parents.push(parent)
                if (parent[key]) {
                    rec(parent)
                }
            }
        }

        rec(current)
        return parents
    }

    async function openDefaultMenu(click = true) {

        if (!forceOpen) {
            return
        }

        function find(f) {
            if (listItems.current) {
                const keys = Object.keys(listItems.current)
                const a = keys.reduce((a, key) => {
                    a.push(listItems.current[key])
                    return a
                }, [])
                return a.find(f)
            }
            return undefined
        }

        const openedFirstListMenu = find((item) => (
            (item.enable && item.sections === 0 && item.state?.open) ||
            (item.enable && item.sections === 0 && item.getStateFromStore && item.getStateFromStore())
        ))

        if (!openedFirstListMenu) {

            let shouldOpenMenu = (defaultOpenMenuKey) ? find((item) => item.menuKey === defaultOpenMenuKey) : undefined
            if (shouldOpenMenu) {
                const parents = getParents(shouldOpenMenu)
                if (parents?.length) {
                    parents.forEach((item) => {
                        if (item.sections === 0 && item.enable) {
                            shouldOpenMenu = item
                        }
                    })
                }
            }

            const resOpenedMenu = find((item) => item.state?.open)
            if (resOpenedMenu && !shouldOpenMenu) {
                if (resOpenedMenu.sections !== 0) {
                    const parents = getParents(resOpenedMenu)
                    if (parents?.length) {
                        parents.forEach((item) => {
                            if (item.sections === 0 && item.enable) {
                                shouldOpenMenu = item
                            }
                        })
                    }
                } else {
                    shouldOpenMenu = resOpenedMenu
                }
            }
            if (!shouldOpenMenu) {
                shouldOpenMenu = find((item) => {
                    return item.enable && item.sections === 0
                })
            }

            if (shouldOpenMenu && !shouldOpenMenu.state?.open && shouldOpenMenu.enable) {
                if (!shouldOpenMenu.button) {
                    await new Promise((resolve) => {
                        const int = setInterval(() => {
                            if (shouldOpenMenu.button) {
                                if (int) {
                                    clearInterval(int)
                                }
                                if (to) {
                                    clearTimeout(to)
                                }
                                resolve()
                            }
                        })
                        const to = setTimeout(() => {
                            if (int) {
                                clearInterval(int)
                                resolve()
                            }
                        }, 1000)
                    })
                }
                if (shouldOpenMenu.button) {
                    if (click) {
                        shouldOpenMenu.button.click()
                        const parents = getParents(shouldOpenMenu, 'parentMenu')
                        parents.forEach((parent) => {
                            if (!parent.enable && parent.button && !parent.state?.open) {
                                parent.button.click()
                            }
                        })
                    } else {
                        return shouldOpenMenu
                    }
                }
            }
        }
    }

    function rec(menu, parent, deep = 0, sections = 0, parentMenu) {
        if (menu?.length) {
            menu.forEach((item, i) => {
                if (item.menuType === 'list' && item.items?.length) {

                    const enable = deep >= startFromDeep && !item.disableMegaMenu

                    delete item.disableMegaMenu
                    delete item.desktopMegaMenuStaticContent

                    if (enable) {
                        item.getListPortalContainer = function() {
                            return container.current?.children[sections + 1]
                        }
                        item.MenuBaseProps = {
                            ...item.MenuBaseProps ? item.MenuBaseProps : {},
                            MenuItemProps: {
                                ...item.MenuBaseProps?.MenuItemProps ? item.MenuBaseProps.MenuItemProps : {},
                                inset: false,
                                style: {
                                    '--karrierhub-menuitem-inset-multiplier': 0
                                }
                            }
                        }
                        item.beforeOpen = async ({ state, setOpen }) => {

                            listItems.current[deep + '_' + i].setOpen = setOpen
                            listItems.current[deep + '_' + i].state = state

                            async function closeAllExceptParents() {
                                const current = listItems.current[deep + '_' + i]
                                const parents = getParents(current)
                                const needClose = []
                                Object.keys(listItems.current).forEach((key) => {
                                    const item = listItems.current[key]
                                    if (parents.indexOf(item) === -1 && current !== item) {
                                        needClose.push(new Promise(async (resolve) => {
                                            if (item.setOpen) {
                                                await item.setOpen(false)
                                            }
                                            resolve()
                                        }))
                                    }
                                })
                                await Promise.all(needClose)
                            }

                            await closeAllExceptParents()

                        }
                        item.onOpen = async ({ setOpen, state }) => {
                            listItems.current[deep + '_' + i].setOpen = setOpen
                            listItems.current[deep + '_' + i].state = state

                            if (container.current?.children[0]) {
                                const parentWidth = container.current.offsetWidth + 10
                                const sectionWidth = container.current.children[0].offsetWidth
                                const showSectionN = Math.max(1, Math.floor(parentWidth / sectionWidth))

                                container.current.children[0].style.marginLeft = Math.min(0, ((sections + 2) * (100 / showSectionN) - 100) * -1) + '%'

                                const lastShowSection = sections + 1
                                const firstShowSection = lastShowSection - (showSectionN - 1)

                                const children = [...container.current.children]
                                children.forEach((child, i) => {
                                    if (i >= firstShowSection && i <= lastShowSection) {
                                        child.style.height = 'auto'
                                        child.style.overflow = 'visible'
                                    } else {
                                        child.style.height = '1px'
                                        child.style.overflow = 'hidden'
                                    }
                                })

                                const setTitle = getSetTitle && getSetTitle()
                                if (setTitle) {
                                    if (sections + 1 >= showSectionN) {
                                        listItems.current[deep + '_' + i].title =
                                            <div className={classNames.menuTitleWithBack}>
                                                <Button
                                                    icon={<BackIcon />}
                                                    onClick={async () => {
                                                        await setOpen(false)
                                                    }}
                                                    variant={'text'}
                                                />
                                                <Typography variant={'h5'} weight={700}>{item.label}</Typography>
                                            </div>
                                        await setTitle(listItems.current[deep + '_' + i].title)
                                    } else {
                                        await setTitle(null)
                                    }
                                }
                            }
                        }
                        item.beforeClose = async ({ e }) => {
                            if (listItems.current[deep + '_' + i].sections === 0 && listItems.current[deep + '_' + i].enable && e) {
                                return true
                            }
                        }
                        item.onClose = async () => {
                            if (container.current?.children[0]) {
                                const parentWidth = container.current.offsetWidth + 10
                                const sectionWidth = container.current.children[0].offsetWidth
                                const showSectionN = Math.max(1, Math.floor(parentWidth / sectionWidth))

                                container.current.children[0].style.marginLeft = Math.min(0, ((sections + 1) * (100 / showSectionN) - 100) * -1) + '%'

                                const lastShowSection = sections
                                const firstShowSection = lastShowSection - (showSectionN - 1)
                                const children = [...container.current.children]
                                children.forEach((child, i) => {
                                    if (i >= firstShowSection && i <= lastShowSection) {
                                        child.style.height = 'auto'
                                        child.style.overflow = 'visible'
                                    } else {
                                        child.style.height = '1px'
                                        child.style.overflow = 'hidden'
                                    }
                                })

                                const setTitle = getSetTitle && getSetTitle()
                                if (setTitle) {
                                    if (sections + 1 >= showSectionN && parent?.title) {
                                        await setTitle(parent.title)
                                    } else {
                                        await setTitle(null)
                                        setTimeout(() => openDefaultMenu(), 1)
                                    }
                                }
                            }
                        }
                        item.EndIconProps = {
                            ClosedStateIcon: ArrowRightIcon,
                            OpenedStateIcon: ArrowRightIcon
                        }
                        item.menuItemSetActiveWhenOpen = true
                    }

                    item.ref = (e) => {
                        listItems.current[deep + '_' + i].button = e
                    }

                    listItems.current[deep + '_' + i] = {}

                    listItems.current[deep + '_' + i].item = item
                    listItems.current[deep + '_' + i].parent = parent
                    listItems.current[deep + '_' + i].sections = sections
                    listItems.current[deep + '_' + i].enable = enable
                    listItems.current[deep + '_' + i].parentMenu = parentMenu
                    listItems.current[deep + '_' + i].menuKey = (parentMenu ? parentMenu.menuKey : menuKey) + '_' + i

                    listItems.current[deep + '_' + i].getStateFromStore = function() {
                        return storageOpenMenu(undefined, true)[(parentMenu ? parentMenu.menuKey : menuKey) + '_' + i]
                    }

                    rec(item.items, enable ? listItems.current[deep + '_' + i] : parent, deep + 1, enable ? sections + 1 : sections, listItems.current[deep + '_' + i])
                }
            })
        }
    }

    const menuRef = useRef(menu.length ? copyObject(menu, { keep: ['desktopMegaMenuStaticContent', 'Component', 'startIcon', 'endIcon', 'icon', 'label'] }) : [])

    const [mountedContainer, setMountedContainer] = useState(container.current)

    useEffect(() => {
        rec(menuRef.current)
        // noinspection JSIgnoredPromiseFromCall
        openDefaultMenu()
    }, [mountedContainer])

    return (
        <div className={classNames.megaMenu}>
            <div
                className={classNames.megaMenuContainer}
                ref={(e) => {
                    container.current = e
                    setMountedContainer(container.current)
                }}
            >
                <>
                    {mountedContainer ?
                        <MenuBase
                            {...MenuBaseProps}
                            menu={menuRef.current}
                            PaperProps={{
                                ContentComponent: 'div',
                                ...MenuBaseProps.PaperProps ? MenuBaseProps.PaperProps : {}
                            }}
                        /> : <div></div>
                    }
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </>
            </div>
            {children ?
                <div className={classNames.megaMenuContent}>
                    {children}
                </div> : null
            }
        </div>
    )
}
